import { useDispatch } from "react-redux"

import { Button } from "@mui/material"
import { ContentContainer, MessageContainer, Title, Subtitle, IconContainer } from "./styled"
import IconBox from "../../components/IconBox"
import UIIcon from "../../components/UIIcon"
import { setNextStep } from "../../store/slices/routingSlice/routingSlice"
import SBPIconNoExt from "../../components/SBPIconNoExt"
import { UpdateDefaultBankSuccessProps } from "./props"
import { UpdateDefaultBankRequestAction } from "../../api/interface"

const UpdateDefaultBankSuccess = ({action}: UpdateDefaultBankSuccessProps) => {
  const dispatch = useDispatch()

  const handleClickDone = () => {
    dispatch(setNextStep())
  }

  const getTitle = () => {
    if (action === UpdateDefaultBankRequestAction.SET)
      return "Успешная установка"
    return "Банк по умолчанию удален из СБП"
  }

  return (
    <ContentContainer>
      <MessageContainer>
        <IconBox size="lg" color="yellow">
          <UIIcon iconName="check" size={45} />
        </IconBox>
        <Title variant="h3">{getTitle()}</Title>
        {action === UpdateDefaultBankRequestAction.SET && (<Subtitle variant="h5">
          РНКО «Единая касса» установлена по умолчанию для получения переводов
          через Систему Быстрых Платежей
        </Subtitle>)
        }
      </MessageContainer>
      <IconContainer>
        <SBPIconNoExt size={60} />
      </IconContainer>
      <Button variant="contained" fullWidth onClick={handleClickDone}>
        Готово
      </Button>
    </ContentContainer>
  )
}

export default UpdateDefaultBankSuccess
